import React from 'react'
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';
import {
    CHILD_TYPE_ACTIONS,
    INTERFACE_TYPE_ACTION_OPTIONS,
    MENU_TYPE_ACTIONS,
} from '../constants/interface.constants';

export default function InterfaceForm({ values, errorInputs, workFlowLists, isEdit, handleInputChange, t }) {
    const isMenu = values.type_action === 'MENU';
    const isSubmenu = values.type_action === 'SUBMENU';
    const isMenuType = MENU_TYPE_ACTIONS.includes(values.type_action);
    const isChildType = CHILD_TYPE_ACTIONS.includes(values.type_action);
    const isMenuOrSubmenu = isMenu || isSubmenu;

    const parentWorkflowOptions = workFlowLists.filter(
        (item) => !item.type_action || item.type_action === 'MENU' || item.type_action === 'SUBMENU'
    );
    const workflowRelatedOptions = parentWorkflowOptions.length ? parentWorkflowOptions : workFlowLists;

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                {t("interface.createEditInterface")}
            </Typography>
            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{xs:4, sm:4}}>
                    <FormControl fullWidth required size='small' disabled={isEdit}
                        error={Boolean(errorInputs.type_action?.isError)}
                    >
                        <InputLabel id="type_action">{t("interface.type")}</InputLabel>
                        <Select name='type_action' label={t("interface.type")}
                            value={values.type_action}
                            onChange={handleInputChange}
                        >
                            {INTERFACE_TYPE_ACTION_OPTIONS.map((option) => (
                                <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                            ))}
                        </Select>
                        {errorInputs.type_action?.isError && <FormHelperText>{errorInputs.type_action.messageError}</FormHelperText>}
                    </FormControl>
                </Grid>

                <Grid size={{xs:4, sm:4}}>
                    <TextField fullWidth required size="small" name="name" label={t("interface.name")}
                        value={values.name}
                        onChange={handleInputChange}
                        error={!!errorInputs.name?.isError}
                        helperText={errorInputs.name?.messageError}
                    />
                </Grid>

                {isMenuOrSubmenu && (
                    <>
                        <Grid size={{xs:4, sm:4}}>
                            <TextField fullWidth size="small" name="process_action" label={t("interface.processAction")}
                                value={values.process_action}
                                onChange={handleInputChange}
                                error={!!errorInputs.process_action?.isError}
                                helperText={errorInputs.process_action?.messageError}
                            />
                        </Grid>

                        <Grid size={{xs:4, sm:4}}>
                            <TextField fullWidth size="small" name="name_action" label={t("interface.nameAction")}
                                value={values.name_action}
                                onChange={handleInputChange}
                                required
                                error={!!errorInputs.name_action?.isError}
                                helperText={errorInputs.name_action?.messageError}
                            />
                        </Grid>

                        <Grid size={{xs:4, sm:4}}>
                            <TextField fullWidth size="small" name="path" label={t("interface.path")}
                                value={values.path}
                                onChange={handleInputChange}
                                required={isMenu}
                                error={!!errorInputs.path?.isError}
                                helperText={errorInputs.path?.messageError}
                            />
                        </Grid>

                        {isMenu && (
                            <Grid size={{xs:4, sm:4}}>
                                <TextField
                                    fullWidth size="small" name="menu" label={t("interface.menuName")}
                                    value={values.menu}
                                    onChange={handleInputChange}
                                    required
                                    error={!!errorInputs.menu?.isError}
                                    helperText={errorInputs.menu?.messageError}
                                />
                            </Grid>
                        )}
                    </>
                )}

                {(isMenuType || isChildType) && (
                    <Grid size={{xs:4, sm:4}}>
                        <TextField fullWidth size="small" name="order_menu" label={t("interface.menuOrder")}
                            value={values.order_menu}
                            onChange={handleInputChange}
                            required={isMenuType || isChildType}
                            error={!!errorInputs.order_menu?.isError}
                            helperText={errorInputs.order_menu?.messageError}
                        />
                    </Grid>
                )}

                <Grid size={{xs:4, sm:4}}>
                    <TextField fullWidth required size="small" name="icon" label={t("interface.icon")}
                        value={values.icon}
                        onChange={handleInputChange}
                        error={!!errorInputs.icon?.isError}
                        helperText={errorInputs.icon?.messageError}
                    />
                </Grid>

                <Grid size={{xs:4, sm:4}}>
                    <TextField
                        fullWidth
                        required={!isChildType}
                        size="small"
                        name="work_flow"
                        label={t("interface.workflow")}
                        value={values.work_flow}
                        onChange={handleInputChange}
                        error={!!errorInputs.work_flow?.isError}
                        helperText={isChildType
                            ? 'Opcional. Identificador único (ej: BUTTON-MI-ACCION)'
                            : errorInputs.work_flow?.messageError}
                    />
                </Grid>

                {(isChildType || isSubmenu) && (
                    <Grid size={{xs:4, sm:4}}>
                        <FormControl fullWidth required={isChildType} size='small'
                            error={Boolean(errorInputs.work_flow_related?.isError)}
                        >
                            <InputLabel id="work_flow_related">{t("interface.workflowRelated")}</InputLabel>
                            <Select
                                label={t("interface.workflowRelated")}
                                name='work_flow_related'
                                value={values.work_flow_related || ''}
                                onChange={handleInputChange}
                            >
                                <MenuItem value="">{isSubmenu ? 'Ninguno' : ''}</MenuItem>
                                {workflowRelatedOptions.map((item, index) => (
                                    <MenuItem value={item.value} key={`${item.value}-${index}`}>
                                        {item.key} ({item.value})
                                    </MenuItem>
                                ))}
                            </Select>
                            <FormHelperText>
                                {errorInputs.work_flow_related?.messageError
                                    || (isSubmenu ? 'Opcional. Menú padre al que pertenece' : 'work_flow del MENU padre')}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                )}
            </Grid>
        </Box>
    )
}
